import { useMeCachedQuery } from '@frameio/shared/hooks';
import { Box, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/SuggestedSearches';
import { SearchCell } from './shared';

TEXT.DEFINE({
  /** Section title for suggested searches */
  title: 'Suggestions',
  /** @notranslate */
  fileTypeIs: 'File Type is audio',
  /** @notranslate */
  uploaderIs: ({ name }: { name: string }) => `Uploader is ${name}`,
  /** @notranslate */
  statusIs: 'Status is needs review',
  /** @notranslate */
  sourceFilenameIs: 'Source Filename is asset-v3.tiff',
  /** @notranslate */
  formatIs: 'Format is PDF',
});

type SuggestedSearchesProps = {
  onClickRecentSearch: (query: string) => void;
};

export const SuggestedSearches = ({
  onClickRecentSearch,
}: SuggestedSearchesProps) => {
  const { data: meData } = useMeCachedQuery();
  const currentUserName = meData?.me?.name ?? '';
  const currentUserFirstName = currentUserName?.split(' ')[0];

  return (
    <div>
      <Box alignItems="center" height={32} padding={8}>
        <Text color="tertiary" fontWeight="medium" variant="secondary">
          {TEXT.title}
        </Text>
      </Box>
      <Box
        alignItems="flex-start"
        display="flex"
        flexDirection="column"
        width="100%"
      >
        <SearchCell
          icon="magnifyingGlass"
          onClick={onClickRecentSearch}
          searchQuery={TEXT.statusIs}
        />
        <SearchCell
          icon="magnifyingGlass"
          onClick={onClickRecentSearch}
          searchQuery={
            TEXT.uploaderIs({
              name: currentUserFirstName || currentUserName,
            }) as string
          }
        />
        <SearchCell
          icon="magnifyingGlass"
          onClick={onClickRecentSearch}
          searchQuery={TEXT.sourceFilenameIs}
        />
        <SearchCell
          icon="magnifyingGlass"
          onClick={onClickRecentSearch}
          searchQuery={TEXT.formatIs}
        />
        <SearchCell
          icon="magnifyingGlass"
          onClick={onClickRecentSearch}
          searchQuery={TEXT.fileTypeIs}
        />
      </Box>
    </div>
  );
};
